<template>
  <div class="daily-report-widget">
    <div class="stats-container daily-report-stats-container">
      <div class="stats-item clickable" v-for="(statItem, index) in measureSuccessItems" :key="index" @click="statItemClicked(statItem)">
        <div class="stats-number">
          {{ statItem.value }}
          <span v-if="statItem.percentage !== null" class="append-data" style="font-size: 0.85rem; color: gray"
            >({{ formatPercentage(statItem.percentage) }})</span
          >
        </div>
        <div class="stats-label">{{ statItem.title }}</div>
      </div>
      <div v-if="measureSuccessItems.length == 0" class="no-data text-center py-2">No data</div>
    </div>

    <div class="daily-report-section-title">Measure Failures</div>
    <div class="stats-container daily-report-stats-container">
      <div class="stats-item clickable" v-for="(statItem, index) in measureFailureItems" :key="index" @click="statItemClicked(statItem)">
        <div class="stats-number">
          {{ statItem.value }}
          <span v-if="statItem.percentage !== null" class="append-data" style="font-size: 0.85rem; color: gray"
            >({{ formatPercentage(statItem.percentage) }})</span
          >
        </div>
        <div class="stats-label">{{ statItem.title }}</div>
      </div>
      <div v-if="measureFailureItems.length == 0" class="no-data text-center py-2">No data</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
  },
  computed: {
    measureFailureItems() {
      return this.items.filter((item) => this.isMeasureFailure(item));
    },
    measureSuccessItems() {
      return this.items.filter((item) => !this.isMeasureFailure(item));
    },
  },
  methods: {
    statItemClicked(item) {
      this.$emit('statItemClicked', item);
    },
    isMeasureFailure(item) {
      const category = String(item.category || '')
        .toLowerCase()
        .replace(/\s+/g, '');
      if (['failure', 'failures', 'measurefailure', 'measurefailures', 'exception', 'exceptions'].includes(category)) {
        return true;
      }
      return /\b(not|without)\b/i.test(item.title || '');
    },
    formatPercentage(value) {
      if (value === null || value === undefined || value === '') return '-';
      const number = Number(value);
      return Number.isFinite(number) ? `${number.toFixed(2)}%` : value;
    },
  },
};
</script>

<style lang="scss">
.daily-report-widget {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: auto;
}

.daily-report-section-title {
  color: #4a5270;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.1;
  margin: 0.5rem 0 0.25rem 0.1rem;
  word-spacing: -2px;
  padding-left: 0.35rem;
}

.daily-report-stats-container {
  height: auto;
  max-height: none;
  padding: 0;
  overflow: visible;
  min-height: fit-content;
}

</style>
